import {
  Box,
  Typography, styled,
} from '@mui/material';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Bold } from '../shared/Styles';

interface ConfirmationDescriptionProps {
  selectedPlan: string;
  selectedMeterId: string;
}

const DescriptionBodyBox = styled(Box)(({ theme }) => ({
  padding: '8px 0',
}));

export function getBold(chunks: any) {
  return <Bold component="span">{chunks}</Bold>;
}

function getParagraph(chunks: any) {
  return <p>{chunks}</p>;
}

export function ConfirmationDescription({ selectedPlan, selectedMeterId }: ConfirmationDescriptionProps) {
  const intl = useIntl();
  return (
    <>
      <Typography variant="h5" gutterBottom data-testid="descriptionTypo">
        <FormattedMessage id="confirm-plan-description.header" />
      </Typography>
      <DescriptionBodyBox data-testid="descriptionTypo">
        <FormattedMessage
          id={`confirm-plan-description-p3-${selectedPlan}`}
          values={{
            bold: getBold,
            meterNum: selectedMeterId,
            planLabel: <FormattedMessage
              id={`confirm-plan-desc-label-${selectedPlan}`}
            />,
            p: (chunks: any) => getParagraph(chunks),
            billString: intl.formatMessage({ id: `${selectedPlan}-plan-bill-string` }),
          }}
        />
      </DescriptionBodyBox>
    </>
  );
}
